import { useFeatureFlags } from "@/configs/featureFlag";

/**
 * リユース資料の販売ページ（/reassist/archive）を開けるか。
 * LaunchDarkly のフラグ reassist-archive が true のときだけ、画面・入口を出す。
 */
export const useReassistArchiveEnabled = (): boolean => {
  const { reassistArchive } = useFeatureFlags();
  return reassistArchive === true;
};
